import React from 'react';
import { connect } from 'react-redux';
import { appContext } from '../../util/decorators';
import { IS_SERVER } from '../../config';

@connect()
@appContext
export default class CookieNotification extends React.PureComponent {
  static propTypes = {
    enabled: React.PropTypes.bool,
    url: React.PropTypes.string,
  };

  componentDidMount() {
    if (this.shouldRenderMessage()) this.embedMessage();
  }

  embedMessage() {
    const t = this.context.app.t;
/*
    this.refs.container.innerHTML = `
      <div class="cookie-notification">
        <div class="container-fluid cookie-content">
          <div class="message">
            ${t('CookieNotification.description')}
            <a href="${this.props.url}">${t('CookieNotification.link_text')}</a>
            <button class="cookie-close">
<a id="CookieInformationDialogBodyButtonAccept" class="CookieInformationDialogBodyButton" href="javascript: CookieConsent.dialog.submitConsent()" class="c-button">JA</a>
            </button>
          </div>
        </div>
      </div>`;
    document.querySelector('.cookie-close').addEventListener('click', this.handleClose);*/
  }

  shouldRenderMessage() {
    return !IS_SERVER && this.props.enabled && !localStorage.getItem('cookie_accepted');
  }

  handleClose = () => {
    this.refs.container.innerHTML = '';

    try {
      localStorage.setItem('cookie_accepted', true);
    } catch (error) {
      console.log('Did not set cookie message as accepted in local storage', error);
    }
  }

  render() {
    return <div ref="container"></div>;
  }
}



// WEBPACK FOOTER //
// ./src/component/Page/CookieNotification.jsx